module.exports = __webpack_public_path__ + "img/button_obnovenie.6c53531e.svg";